import React from 'react'

import AppLayout from '@microsites/components/AppLayout'
import EULALayout from '@microsites/components/EULALayout/EULALayout'

import Content from './community_guidelines.md'

/**
 *
 */
export default function CommunityGuidelinesPage() {
  return <Content />
}

CommunityGuidelinesPage.getLayout = (page) => {
  return (
    <AppLayout>
      <EULALayout>{page}</EULALayout>
    </AppLayout>
  )
}
